import { node, } from '../../jsCore/utils/dom';
import { TYPES, } from '../../jsCore/organizedByType/actions/userToolbarActions';
import { appDispatcher } from '../../jsCore/application/AppDispatcher';
import userStore from '../../jsCore/organizedByType/stores/userStore';
import { SELECTORS, } from '../../jsCore/config/preRenderedSelectorsConfig';
import { fbLogin, } from '../../jsCore/organizedByType/actions/userToolbarActions';


function redirectIfExistingUser(redirectUrl, { type, }) {
  if (type === TYPES.EXISTING_USER_AUTHENTICATED) {
    window.location = redirectUrl;
  }
}

function loginButtonOnClick(e) {
  if (!userStore.state.loggedIn) {
    e.preventDefault();
    appDispatcher.register(redirectIfExistingUser.bind(0, e.target.href));
    fbLogin();
  }
}

export default function mountWritersLoginButton(){
  const writersLoginButton = node(SELECTORS.WRITERS_ARTICLE_BUTTON);
  if (writersLoginButton) {
    writersLoginButton.addEventListener('click', loginButtonOnClick);
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/static_pages_content/writersLoginButton.js